export default "{\n    \"emptyState\": \"Non spécifié\"\n}\n"